module.exports = __webpack_public_path__ + "img/icon_map_37_off_110.978ec020.png";